import { render, staticRenderFns } from "./relatedArticles.vue?vue&type=template&id=4ef13442&scoped=true&"
import script from "./relatedArticles.vue?vue&type=script&lang=js&"
export * from "./relatedArticles.vue?vue&type=script&lang=js&"
import style0 from "./relatedArticles.vue?vue&type=style&index=0&id=4ef13442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef13442",
  null
  
)

export default component.exports